angular.module('jv.candidates.contact.factory', [])
.factory('jvCandidatesContactFactory',['$rootScope', 'jvCandidatesService', function($rootScope, jvCandidatesService) {
        var _contactInfo = {};
        return {
            setContactInfo: function(candidateEId, callback) {
                var args = {
                    candidateEid: candidateEId,
                    platforms: 'Linkedin,Twitter'
                }
                jvCandidatesService.getContactInfoForCandidate(args, function(response) {
                    if (response && angular.isDefined(response.data)) {
                        _contactInfo[candidateEId] = response.data;
                        callback(response.data);
                    }
                });
            },

            getContactInfo: function(candidateEId, callback) {
                if (angular.isDefined(_contactInfo[candidateEId]) && angular.isDefined(_contactInfo[candidateEId].resultList)) {
                    callback(_contactInfo[candidateEId].resultList[0]);
                } else {
                    this.setContactInfo(candidateEId, function() {
                    	if(_contactInfo[candidateEId].resultList){
                    		callback(_contactInfo[candidateEId].resultList[0]);                    		
                    	}
                    });
                }
            }
        };
    }
]);
